module.exports = __webpack_public_path__ + "img/t5-c1.24c7b848.png";